module.exports = __webpack_public_path__ + "img/calculator.62eed44c.png";